import {setFetchingForView, setMetaProp, setView, setCurrent, bulkUpdate, upsert, patch, setComplete} from '../../../helpers'

export default {
  setView,
  setFetchingForView,
  setMetaProp,
  setCurrent,
  bulkUpdate,
  upsert,
  patch,
  setComplete
}



// WEBPACK FOOTER //
// ./src/store/modules/topics/mutations.js